import type { FaireProductEntity } from "../../entity_types/product";

export const p_jscgnuu3jz: FaireProductEntity = {
  token: "p_jscgnuu3jz",
  type: "product",
  name: "Sticker Book  Issue Five",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/b05af79c2c9eef02e08e94fa81a68e14ab37d896dac2912414134ca1bd660d28.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "It wouldn’t be a planner release without a new sticker book—and this one is really, really, really good. Inside, you’ll find 35 pages with over 700 stickers, featuring everything from important reminders to cute dogs to words of encouragement. Whether you’re decorating your planner, journaling, or just adding a little extra joy to your notes, these stickers make organizing way more fun.\n\nFeatures:\n\n35 pages filled with 700+ colorful stickers\n\nIncludes reminders, icons, affirmations, and playful designs\n\nPerfect for planners, notebooks, scrapbooks, or cards\n\nCompact, portable, and easy to take on the go\n\nDesigned in Bando’s signature bright, positive aesthetic\n\n\nIdeal For:\n\nGift shops and stationery boutiques\n\nBookstores, office supply retailers, and planner enthusiasts\n\nBack-to-school or creative craft collections\n\nWholesale buyers seeking fun, functional stationery accessories",
  tags: [],
  msrpDollars: 13.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:40.131Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
